export default {
  docs_pending: false,
  docs: []
}
